import { frontendURL } from '../../../helper/URLHelper';

const SegmentsIndex = () => import('./SegmentsIndex.vue');
const SegmentBuilder = () => import('./SegmentBuilder.vue');

// segments are admin-only unless a custom role grants segment_view/segment_manage;
// default-role agents have no access
const meta = {
  permissions: ['administrator', 'segment_view', 'segment_manage'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/segments'),
    name: 'contact_segments_index',
    component: SegmentsIndex,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/segments/new'),
    name: 'contact_segments_new',
    component: SegmentBuilder,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/segments/:segmentId'),
    name: 'contact_segments_show',
    component: SegmentBuilder,
    props: route => ({ segmentId: route.params.segmentId }),
    meta,
  },
];
